import React from 'react';
import { 
  Typography,
  Box,
  Divider,
} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import autovalid360PlanBlue from '../../assets/images/autovalid360_plan_blue.svg';

const SERVICES = [
  'Pesquisa de procedência;',
  'Leilão;',
  'Sinistro;',
  'Furto;',
  'Impedimentos;',
  'Restrições judiciais;',
  'Débitos.'
];

// 2. Componentes reutilizáveis
const ServiceItem = React.memo(({ text }) => (
  <Box 
    component="li" 
    sx={{
      display: 'flex',
      alignItems: 'center',
      mb: 0,
      fontWeight: 100,
      '&::before': {
        content: '"•"',
        fontWeight: 'bold',
        display: 'inline-block',
        width: '1em',
        marginLeft: '0.5em'
      }
    }}
  >
    {text}
  </Box>
));

// 5. Componente principal otimizado
export default function BasicPlanCard() {
  // Memoização dos serviços
  const servicesList = React.useMemo(() => 
    SERVICES.map((item) => (
      <ServiceItem key={item} text={item} />
    )), 
  []);

  return (
    <Box sx={{ 
      bgcolor: '#FFFFFF',
      borderRadius: { xs: 2, sm: 3, md: 4 },
      p: { xs: 2, sm: 3, md: 4 },
      boxShadow: '0px 6px 24px 0px #012F473A',
      borderTop: '4px solid #51DF94',
      height: '100%',
    }}>
      {/* Estrelas */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center',
        gap: 1,
        mb: 4
      }}>
        {['star-1', 'star-2', 'star-3', 'star-4', 'star-5'].map((starId) => (
          <StarIcon key={starId} sx={{ color: '#51DF94' }} />
        ))}
      </Box>

      {/* Logo */}
      <Box sx={{ 
        textAlign: 'center',
        mb: 3
      }}>
        <img 
          src={autovalid360PlanBlue} 
          alt="Autovalid 360 Plan" 
          style={{ maxWidth: '200px' }}
        />
      </Box>

      {/* Linha divisória */}
      <Divider 
        sx={{ 
          bgcolor: '#239CC4',
          height: '4px',
          mb: 3
        }} 
      />

      {/* Lista de serviços */}
      <Typography 
        variant="h6" 
        sx={{ 
          color: '#012F47',
          fontWeight: 600,
          mb: 1
        }}
      >
        Histórico Veicular
      </Typography>

      <Box component="ul" sx={{ 
        listStyle: 'none',
        p: 0,
        m: 0
      }}>
        {servicesList}
      </Box>
    </Box>
  );
}